import { type LegalEntity, LegalEntityType } from '@omnipresentgroup/types';

import { DEFAULT_PAYROLL_PROVIDER } from '../payrollProviders';

export const DEFAULT_LEGAL_ENTITY: LegalEntity = {
  id: 'legal-entity-id-01',
  lspId: 'LSP-21-001',
  name: 'EOR Legal Entity',
  type: LegalEntityType.EMPLOYER_OF_RECORD,
  countryCode: 'GB',
  isOmniEntity: false,
  isActive: true,
  createdAt: '2023-07-19T14:33:48.878Z',
  updatedAt: '2023-07-20T14:39:48.878Z',
  payrollProvider: DEFAULT_PAYROLL_PROVIDER,
  cutoffReportDays: [
    {
      id: 'cutoff-report-day-id-01',
      cutoffReportDay: 8,
      createdAt: '2025-05-21T13:43:28.413Z',
      cutoffReportDayOverrides: [
        {
          id: 'cutoff-report-day-override-id-01',
          targetYearMonth: '2025-06-01',
          cutoffReportDate: '2025-06-09',
          createdAt: '2025-05-21T13:43:28.413Z',
          cutoffReportDayId: 'cutoff-report-day-id-01',
          createdBy: 'user-id-01',
        },
        {
          id: 'cutoff-report-day-override-id-02',
          targetYearMonth: '2025-12-01',
          cutoffReportDate: '2025-12-12',
          createdAt: '2025-05-21T13:43:28.413Z',
          cutoffReportDayId: 'cutoff-report-day-id-01',
          createdBy: 'user-id-01',
        },
      ],
    },
  ],
  nextCutoffDates: [
    '2025-06-07T21:59:00.000Z',
    '2025-06-15T21:59:00.000Z',
    '2025-07-07T21:59:00.000Z',
    '2025-07-15T21:59:00.000Z',
    '2025-08-07T21:59:00.000Z',
    '2025-08-15T21:59:00.000Z',
    '2025-09-07T21:59:00.000Z',
    '2025-09-15T21:59:00.000Z',
    '2025-10-07T21:59:00.000Z',
    '2025-10-15T21:59:00.000Z',
    '2025-11-07T22:59:00.000Z',
    '2025-11-15T22:59:00.000Z',
  ],
};

export const OMNI_LEGAL_ENTITY: LegalEntity = {
  ...DEFAULT_LEGAL_ENTITY,
  id: 'legal-entity-id-02',
  name: 'Omni Legal Entity',
  isOmniEntity: true,
  type: LegalEntityType.CONSULTING_ENTITY,
  countryCode: 'ES',
};

export const VO_LEGAL_ENTITY: LegalEntity = {
  ...DEFAULT_LEGAL_ENTITY,
  id: 'legal-entity-id-03',
  name: 'Virtual Legal Entity',
  type: LegalEntityType.VIRTUAL_EMPLOYER,
  countryCode: 'US',
};

export const PEO_LEGAL_ENTITY: LegalEntity = {
  ...DEFAULT_LEGAL_ENTITY,
  id: 'legal-entity-id-04',
  name: 'PEO Legal Entity',
  type: LegalEntityType.PROFESSIONAL_EMPLOYMENT_ORGANISATION,
  countryCode: 'CA',
};

export const PENDING_LEGAL_ENTITY: LegalEntity = {
  ...DEFAULT_LEGAL_ENTITY,
  id: 'legal-entity-id-05',
  name: 'Pending Legal Entity',
  type: LegalEntityType.PENDING,
  countryCode: 'FR',
};

const INACTIVE_LEGAL_ENTITY: LegalEntity = {
  ...DEFAULT_LEGAL_ENTITY,
  id: 'legal-entity-id-06',
  name: 'Inactive Legal Entity',
  isActive: false,
  countryCode: 'ES',
};

export const GET_LEGAL_ENTITIES_RESPONSE = [
  { ...DEFAULT_LEGAL_ENTITY, nextCutoffDate: '2025-06-07T23:59:00.000Z' },
  { ...OMNI_LEGAL_ENTITY, nextCutoffDate: '2025-06-07T23:59:00.000Z' },
  { ...VO_LEGAL_ENTITY, nextCutoffDate: '2025-06-07T23:59:00.000Z' },
  { ...PEO_LEGAL_ENTITY, nextCutoffDate: '2025-06-07T23:59:00.000Z' },
  { ...PENDING_LEGAL_ENTITY, nextCutoffDate: '2025-06-07T23:59:00.000Z' },
  { ...INACTIVE_LEGAL_ENTITY, nextCutoffDate: null },
];
